import Course from '../../../api/Course';
import * as types from './mutation-types';

export const store = async ({commit}, {params}) => {
    await new Course().store(params)
};

export const show = async ({commit}, {id}) => {
    const json = await new Course().show(id);

    commit(types.COURSE, json);

};

export const update = async (context, {id, params}) => {
    await new Course().update(id, params)
};

export const updateCourseStatus = async (context, {id, params}) => {
    await new Course().updateCourseStatus(id, params)
};

export const destroy = async (context, {id}) => {
    await new Course().destroy(id)
};

export const getAll = async ({commit}) => {
    const json = await new Course().getAll();

    commit(types.COURSES, json);
};

export const getAllForSelect = async (context, params = null) => {
    return await new Course().getAll(params);
};

export const assignStudent = async (context, { params }) => {
    await new Course().assignStudent(params)
};

export const reassignStudent = async (context, { params }) => {
    await new Course().reassignStudent(params)
};

export const trackProgress = async (context, { id }) => {
    return await new Course().trackProgress(id)
};

export default {
    store,
    show,
    update,
    updateCourseStatus,
    destroy,
    getAll,
    getAllForSelect,
    assignStudent,
    reassignStudent,
    trackProgress,
};



// WEBPACK FOOTER //
// ./src/store/modules/course/actions.js